import styled from 'styled-components';

export const Description = styled.div`
  img {
    max-width: 100%;
  }
`;
